import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  caseId: string | null;
}

export const useDownloadDocumentsList = ({ caseId }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadDocumentsList = async ({
    format,
    title,
    columns,
    searchQuery,
    processed,
    extensions,
    startDate,
    endDate,
    documentTypes,
    documentThemes,
    hasKeyFacts,
    hasRelevantFacts,
  }: {
    format: string;
    title: string;
    columns: string[];
    searchQuery?: string;
    processed?: boolean;
    extensions?: string[];
    startDate?: string;
    endDate?: string;
    documentTypes?: string[];
    documentThemes?: string[];
    hasKeyFacts?: boolean;
    hasRelevantFacts?: boolean;
  }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        format,
        caseId,
        title,
        columns,
        searchQuery,
        processed,
        extensions,
        startDate,
        endDate,
        documentTypes,
        documentThemes,
        hasKeyFacts,
        hasRelevantFacts,
      },
    });

    const blob = await (await fetch(`${APIBaseChronos}/api/case/${caseId}/docs/download-list/`, fetchConfig)).blob();

    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: `${title}.${format}`,
    });

    link.click();

    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading: isLoadingDownload } = useMutation(downloadDocumentsList);

  return { fetchDownload, isLoadingDownload };
};
